import { useWindowSize } from '@app/hooks';

import { useLeadsRegistryPage } from '../hooks';

import { LeadsRegistryCards } from './components/LeadsRegistryCards';
import { LeadsRegistryTable } from './components/LeadsRegistryTable';

import type { FC } from 'react';

import './LeadsRegistryPage.scss';

const LEADS_REGISTRY_CARDS_MAX_WIDTH = 800;

export const LeadsRegistryPage: FC = () => {
  const { hasMoreLeads, isLoadingMore, onLoadMore, tableRows } =
    useLeadsRegistryPage();
  const { innerWidth } = useWindowSize();
  const shouldRenderCards = innerWidth <= LEADS_REGISTRY_CARDS_MAX_WIDTH;

  return (
    <section className="LeadsRegistryPage">
      {shouldRenderCards ? (
        <LeadsRegistryCards
          hasMoreLeads={hasMoreLeads}
          isLoadingMore={isLoadingMore}
          rows={tableRows}
          onLoadMore={onLoadMore}
        />
      ) : (
        <LeadsRegistryTable
          hasMoreLeads={hasMoreLeads}
          isLoadingMore={isLoadingMore}
          rows={tableRows}
          onLoadMore={onLoadMore}
        />
      )}
    </section>
  );
};
